module.exports = __webpack_public_path__ + "img/weddings_19_V.b8d70039.webp";